import PropTypes from "prop-types";

import HandOptimizedRawReadAloudGraphicLarge from "./HandOptimizedRawReadAloudGraphicLarge.svg.jsx";
import HandOptimizedRawReadAloudGraphicMedium from "./HandOptimizedRawReadAloudGraphicMedium.svg.jsx";
import HandOptimizedRawReadAloudGraphicSmall from "./HandOptimizedRawReadAloudGraphicSmall.svg.jsx";

const propTypes = {
  currentRange: PropTypes.string,
};

const ReadAloudGraphic = ({ currentRange }) => {
  const renderGraphic = () => {
    if (currentRange === "md to lg" || currentRange === "lg to infinity") {
      return <HandOptimizedRawReadAloudGraphicLarge />;
    } else if (currentRange === "sm to md") {
      return <HandOptimizedRawReadAloudGraphicMedium />;
    } else if (currentRange === "xs to sm") {
      return <HandOptimizedRawReadAloudGraphicSmall />;
    } else if (currentRange === "zero to xs") {
      return null;
    } else {
      return null;
    }
  };

  return <>{renderGraphic()}</>;
};

ReadAloudGraphic.propTypes = propTypes;
export default ReadAloudGraphic;
